import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTT: CultureInfo = {
  name: 'en-TT',
  displayName: 'English (Trinidad & Tobago)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TT',
  parent: CultureInfoEn
};
